/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImageResource } from './imageResource';
import { BranchResource } from './branchResource';
import { BrokerResource } from './brokerResource';
import { ItemResource } from './itemResource';
import { SellerResource } from './sellerResource';


export interface OrderDetailResource { 
    orderId: number;
    currency: string;
    price: string;
    location: string;
    state: string;
    type: string;
    kind: string;
    description: string;
    title: string;
    images: Array<ImageResource>;
    items: Array<ItemResource>;
    broker: BrokerResource;
    branch: BranchResource;
    seller: Array<SellerResource>;
}

